/* ATTAR shop pages: header shade, product photographs, add to bag without leaving the page, quantities, sort, slim buy bar. */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* header: shade once the page moves (shop pages only) */
  const header = () => document.querySelector('[data-axc-header]');
  const onScroll = () => { const h = header(); if (h) h.classList.toggle('is-scrolled', scrollY > 40); };
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* bag count in the header */
  function setBag(count) {
    document.querySelectorAll('[data-axs-bag-count]').forEach(n => { n.textContent = count; });
    document.querySelectorAll('[data-axs-bag]').forEach(a => { a.classList.remove('is-bump'); void a.offsetWidth; a.classList.add('is-bump'); });
  }

  /* product photographs: thumbnails beside, swipe on phones */
  function gallery(g) {
    if (g.dataset.axsReady) return; g.dataset.axsReady = '1';
    const stage = g.querySelector('[data-axs-stage]');
    const slides = [...g.querySelectorAll('[data-axs-slide]')];
    const thumbs = [...g.querySelectorAll('[data-axs-thumb]')];
    const dots = [...g.querySelectorAll('.axs-dots span')];
    const show = id => {
      slides.forEach(s => s.classList.toggle('is-active', s.dataset.axsSlide === id));
      thumbs.forEach(t => t.setAttribute('aria-current', t.dataset.axsThumb === id ? 'true' : 'false'));
    };
    thumbs.forEach(t => t.addEventListener('click', () => show(t.dataset.axsThumb)));
    if (stage && dots.length) {
      stage.addEventListener('scroll', () => {
        const i = Math.round(stage.scrollLeft / stage.clientWidth);
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      }, { passive: true });
    }
  }

  /* quantity steppers (product and bag) */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-axs-step]');
    if (!b) return;
    const input = b.closest('[data-axs-qty]').querySelector('input');
    const min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.axsStep, 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* bag page: changing a quantity updates the bag */
  let t;
  document.addEventListener('change', e => {
    const i = e.target.closest('[data-axs-autosubmit]');
    if (!i) return;
    clearTimeout(t);
    t = setTimeout(() => {
      const f = i.form;
      const u = f.querySelector('button[name="update"]');
      if (f.requestSubmit) f.requestSubmit(u); else u.click();
    }, 450);
  });

  /* collection sort */
  document.addEventListener('change', e => {
    const s = e.target.closest('[data-axs-sort]');
    if (!s) return;
    const url = new URL(location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    location.href = url.toString();
  });

  /* add to bag without leaving the page */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-axs-form]');
    if (!form || e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    const btn = form.querySelector('[data-axs-add]');
    const msg = form.parentElement.querySelector('[data-axs-msg]');
    if (!btn || btn.disabled) return;
    btn.classList.add('is-busy');
    if (msg) { msg.classList.remove('is-error'); msg.textContent = ''; }
    try {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Could not add to the bag.');
      const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      setBag(cart.item_count);
      document.dispatchEvent(new CustomEvent('axs:added', { detail: { cart } }));
      if (msg) msg.innerHTML = 'Added to your bag. <a href="' + root + 'cart">View the bag</a>';
    } catch (err) {
      if (msg) { msg.classList.add('is-error'); msg.textContent = err.message; }
    } finally {
      btn.classList.remove('is-busy');
    }
  });

  /* slim buy bar once the main button has scrolled away */
  function stickyBar(p) {
    const bar = p.querySelector('[data-axs-sticky]');
    const add = p.querySelector('[data-axs-add]');
    if (!bar || !add || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([en]) => {
      const past = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(b => b.tabIndex = past ? 0 : -1);
    });
    io.observe(add);
    const go = bar.querySelector('[data-axs-sticky-add]');
    if (go) go.addEventListener('click', () => { const f = add.form; if (f.requestSubmit) f.requestSubmit(add); else add.click(); add.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  }

  /* tall sections (a long grid on a phone) never reach the 15% the house reveal waits for: reveal them once their top is on screen */
  const tio = 'IntersectionObserver' in window
    ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); tio.unobserve(e.target); } }), { rootMargin: '0px 0px -12% 0px' })
    : null;
  function tall() {
    document.querySelectorAll('.axs-wrap [data-axh-reveal]:not(.is-in), .axs-wrap[data-axh-reveal]:not(.is-in)').forEach(el => tio ? tio.observe(el) : el.classList.add('is-in'));
  }

  function init() {
    tall();
    document.querySelectorAll('[data-axs-gallery]').forEach(gallery);
    document.querySelectorAll('[data-axs-product]').forEach(p => { if (!p.dataset.axsBar) { p.dataset.axsBar = '1'; stickyBar(p); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', () => setTimeout(init, 50));
})();
